module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_rogaland_neg.626cf888.pdf";